import { Box } from 'grommet';
import { ComponentProps } from 'preact';

import TourBannerSlot from '@/components/AllAccessGuidedTour/TourBannerSlot';
import { cn } from '@/lib/utils';

const PageWrapper = ({ children, className, ...props }: ComponentProps<'div'>) => {
  return (
    <Box fill className="pageWrapper">
      <Box fill overflow="auto">
        <div
          className={cn(
            'preflight relative mx-auto flex size-full min-w-[350px] max-w-[var(--maxWidth)] flex-col overflow-hidden bg-white desktop:overflow-y-auto',
            className,
          )}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...props}
        >
          <TourBannerSlot />
          {children}
        </div>
      </Box>
    </Box>
  );
};

export default PageWrapper;
